<template>
  <div v-title="$route.meta.title">
    <div class="page-heading header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="申请人"
                        prop="applicant">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入申请人名称，仅显示活跃状态的管理员"
              v-model="search.applicant"
              :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1,2,3,5]}))"
              :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="部门"
                        prop="department_id">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入部门名称"
              v-model="search.department_id"
              :query-request="fetchDepartments"
              :find-request="getDepartmentDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="付款类型"
                        prop="type">
            <el-select v-model="search.type" clearable
                       multiple
                       class="width-max">
              <el-option v-for="(label, key) in {...type, 4: '批量付款'}"
                         :key="key"
                         :label="label"
                         :value="key">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="审批状态"
                        prop="approve_status">
            <el-select v-model="search.approve_status"
                       class="width-max"
                       multiple
                       clearable>
              <el-option v-for="item in searchApproveStatus"
                         :key="item.key"
                         :label="item.label"
                         :value="item.key">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="付款状态"
                        prop="payment_status">
            <el-select v-model="search.payment_status"
                       clearable
                       multiple
                       class="width-max">
              <el-option v-for="item in searchPaymentStatus"
                         :key="item.key"
                         :label="item.label"
                         :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="申请日期"
                        prop="created_at">
            <el-date-picker
                v-model="search.created_at"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max"
                :default-time="['00:00:00', '23:59:59']"
                clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="付款日期"
                        prop="paid_date">
            <el-date-picker
                v-model="search.paid_date"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max"
                :default-time="['00:00:00', '23:59:59']"
                clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="应付金额">
            <el-col :span="11">
              <el-form-item prop='apply_amount_min'>
                <el-input v-model="search.apply_amount_min" placeholder="请输入应付金额起始值"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <p style="padding: 0; margin: 0; text-align: center">至</p>
            </el-col>
            <el-col :span="11">
              <el-form-item prop='apply_amount_max'>
                <el-input v-model="search.apply_amount_max" placeholder="请输入应付金额起始值"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="是否加急"
                        prop="is_urgent">
            <el-select v-model="search.is_urgent" clearable
                       class="width-max">
              <el-option v-for="(label, key) in {1: '是', 0: '否'}"
                         :key="key"
                         :label="label"
                         :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款ID"
                        prop="id">
            <el-input v-model="search.id" placeholder="请输入付款ID"></el-input>
          </el-form-item>

          <el-form-item label="冲销时间"
                        prop="write_off_at">
            <el-date-picker
              v-model="search.write_off_at"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              class="width-max"
              :default-time="['00:00:00', '23:59:59']"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="冲销状态"
                        prop="write_off_status">
            <el-select v-model="search.write_off_status" clearable
                       multiple
                       class="width-max">
              <el-option v-for="(label, key) in writeOffStatus"
                         :key="key"
                         :label="label"
                         :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款公司"
                        prop="payment_company">
            <remote-select
              multiple
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="仅支持搜索启用中的付款公司,可输入名称进行搜索"
              v-model="search.payment_company"
              :query-request="(_)=>fetchOurCompanies(Object.assign(_, {is_disabled: 0}))"
              :find-request="getOurCompaniesDetail">
            </remote-select>
          </el-form-item>

        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="primary"
                   icon="sj-icon-export"
                   @click="exportFinancePaymentList()"
                   size="small">按财务格式导出
        </el-button>
        <el-button type="primary"
                   icon="sj-icon-export"
                   @click="exportFinancePaymentDetail()"
                   size="small">导出付款明细
        </el-button>
        <el-button type="primary"
                   icon="sj-icon-export"
                   @click="exportFinanceWriteOffDetail()"
                   size="small">导出预付款冲销明细
        </el-button>
        <el-button type="primary"
                   icon="sj-icon-export"
                   @click="exportFinanceWriteOffStatus()"
                   size="small">导出预付款冲销状态明细
        </el-button>

        <el-button type="primary"
                   @click="showSummaryVisible"
                   size="small">按搜索结果汇总
        </el-button>
        <el-button type="primary"
                    icon="sj-icon-pdf"
                    @click="onDownLoadPDFS"
                    :disabled="!multipleSelection.length"
                    size="small">批量生成PDF
        </el-button>
        <el-button type="primary"
                   size="small"
                   :disabled="!multipleSelection.length"
                   @click="openBatchPaymentDialog">批量银行付款
        </el-button>
      </div>
      <payment-center-table-list
        ref="table"
        :data="table"
        :cell-style="cellStyle"
        :show-operation-column="[1,5].includes(user.usertype * 1)"
        @selection-change="val => this.multipleSelection = val">
        <template #operation="{row}">
          <button-gutter>
            <router-link :to="`/payment-center/detail/${row.id}`">
              <el-button size="mini" type="success">查看</el-button>
            </router-link>

            <template  v-if="row.status === 17">
              <!-- 状态17: 支付异常，支付异常时，只显示"处理支付异常按钮和查看按钮" -->
              <el-button
                type="danger"
                size="mini"
                @click="handleProcessPayException(row)"
              >
                处理支付异常
              </el-button>
            </template>

            <template v-else>
              <!-- 状态7：拒付/付款相关操作 -->
              <el-button
                v-if="row.status === 7"
                type="danger"
                size="mini"
                @click="checkRejectPermission(row)"
              >
                拒付
              </el-button>
              <!-- 零工提现（payment_channel_type=2）到支付宝(payment_account_type=2)，微信(payment_account_type=3)，不需要显示银行自动支付 -->
              <el-button
                v-if="row.is_bank_pay === 1"
                type="warning"
                size="mini"
                @click="openPayDialog(row)"
              >
                银行自动支付
              </el-button>
              <!-- 状态7/8/10/16：付款信息回填,待付款/已付款/已部分付款/支付中 都支持付款信息回填， 8，10，16 需要调用新接口进行上传，且附件只能有一个-->
              <el-button
                v-if="showUploadReceipt(row)"
                type="warning"
                size="mini"
                @click="handleUploadReceipt(row)"
              >
                付款信息回填
              </el-button>

              <!-- 状态8/10(已付款/已部分付款)：手动推送金蝶 -->
              <el-button
                v-if="[8, 10].includes(row.status) && row.is_push_kingdee === 1"
                type="danger"
                size="mini"
                @click="handlePushKingDee(row)"
              >
                推送金蝶失败
              </el-button>

              <!-- 状态8：退款 -->
              <el-button
                v-if="[8, 10].includes(row.status) && row.paid_amount_total * 1 > 0 && row.paid_amount_total !== row.refund_amount_total && row.type !== 5"
                type="warning"
                size="mini"
                @click="onRefund(row)"
              >
                退款
              </el-button>

              <!-- 下载文件 -->
              <el-button
                v-if="row.is_download_pay_result === 1"
                type="warning"
                size="mini"
                :loading="downloadPayResultLoading[row.id]"
                :disabled="downloadPayResultLoading[row.id]"
                @click="onDownloadPayRes(row)"
              >
                导出批量付款明细
              </el-button>
            </template>

          </button-gutter>
        </template>
      </payment-center-table-list>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <payment-pay-dialog
      :visible.sync="payDialogVisible"
      :row="currentRow"
      @finished="onFinished">
    </payment-pay-dialog>
  </div>
</template>

<script>
import { searchRules } from '../payment-center.rules.js'
import { downloadPayResult, processPayException } from '../payment-center.api.js'
import downloadJS from '@/vendor/download'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table, { removeEmptyParams } from '@core/mixins/table-v3'
import paymentCenterMixins from '../payment-center.mixins'
import paymentInfoExportMixins from '@views/payment-manager-new/payment-info-export.mixins'
import PaymentPayDialog from '../components/PaymentPayDialog.vue'
import PaymentCenterTableList from '../components/PaymentCenterTableList.vue'
import { getToken } from '@utils/auth'

export default {
  name: 'PaymentCenterTable',
  components: {
    PaymentPayDialog,
    PaymentCenterTableList,
  },
  mixins: [table, dateTimePicker, paymentCenterMixins, paymentInfoExportMixins],
  data () {
    return {
      searchRules,
      search: {
        applicant: null,
        type: [],
        department_id: null,
        payment_company: [],
        // approve_status: [],
        payment_status: [],
        created_at: [],
        paid_date: [],
        write_off_at: [],
        write_off_status: [],
        apply_amount_min: null,
        apply_amount_max: null,
        is_urgent: null,
        id: null,
        is_from_finance: true,
      },
      searchFieldType: {
        is_urgent: String,
        applicant: Number,
        department_id: Number,
      },
      multipleSelection: [],
      paymentCompanys: {},
      originFirstSubjects: {},
      originSecondSubjects: {},
      summaryVisible: false,
      paymentSummary: [],
      payDialogVisible: false,
      currentRow: null,
      // 防止频繁点击：按 row.id 维度加锁
      downloadPayResultLoading: {},
    }
  },
  computed: Vuex.mapState({
    type: state => state.paymentManagerNew.type,
    // searchApproveStatus: state => state.paymentManager.searchApproveStatus,
    searchPaymentStatus: state => state.paymentManagerNew.searchPaymentStatus,
    user: state => state.login.user,
    invoiceType: state => state.paymentManagerNew.invoiceType,
    writeOffStatus: state => state.paymentManagerNew.writeOffStatus,
  }),
  async created () {
    await this.getFinCenterConfigs()
  },
  methods: {
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getPaymentCenterList', params)
    },
    exportTableData (params) {
      return request.page('exportTableData', params)
    },
    getFinCenterConfigs () {
      return request.common('getFinCenterConfigs').then(({data}) => {
        this.setupSubjects(data)
        this.setupPaymentCompany(data)
      })
    },
    setupSubjects (data) {
      this.originFirstSubjects = this.expandData(_.values(data.first_subject_source))
      this.originSecondSubjects = this.expandData(_.values(data.second_subject_source))
    },
    setupPaymentCompany (data) {
      this.paymentCompanys = data.payment_apply_our_company_source.reduce((o, k) => {
        o[k.id] = k.name
        return o
      }, {})
    },
    expandData (data) {
      let result = {}
      for (const dataKey in data) {
        const tmp = data[dataKey]
        result[tmp.id] = tmp.name
      }
      return result
    },
    fetchDepartments (name) {
      return request.common('getFinCenterDepartmentTableList', {query_all: true, ...name})
    },
    getDepartmentDetail (id) {
      return request.common('getFinCenterDepartmentDetail', id)
    },
    cellStyle (row) {
      // 加急，且处于 待审批,财务审批,待付款,待修改 状态的条目,标红处理
      if (row.row.is_urgent && [1, 2, 3, 4, 5, 6, 7, 11, 13, 14].includes(row.row.status * 1)) {
        return 'color:red;font-weight:bold;'
      }

      // 新增：支付异常状态，整行文字也标红
      if (row.row.status === 17) {
        return 'color:red;font-weight:bold;'
      }
    },
    fetchOurCompanies (params) {
      return request.common('getFinCenterOurCompaniesTable', params)
    },
    getOurCompaniesDetail (id) {
      return request.common('getFinCenterOurCompaniesDetail', id).then(data => {
        data.data.id = String(data.data.id)
        return data
      })
    },
    isAllowBatchSubmit (row) {
      // 后端返回 is_batch_submit 标识是否允许批量提交
      if (Object.prototype.hasOwnProperty.call(row, 'is_batch_submit')) {
        return row.is_batch_submit * 1 === 1
      }
      // 兼容旧数据：收款对象名称以“零工提现”开头的数据不能进行批量付款
      const name = row.company_name || ''
      return !name.startsWith('零工提现')
    },
    openBatchPaymentDialog () {
      const notAllowBatchSubmitIds = this.multipleSelection.filter(item => !this.isAllowBatchSubmit(item)).map(item => item.id)
      if (notAllowBatchSubmitIds.length) {
        const desc = `ID为 ${notAllowBatchSubmitIds.join(', ')} 的付款申请不可批量支付，请重新选择`
        this.$confirm(desc, '', {type: 'warning', showCancelButton: false, showConfirmButton: false}).then(() => {})
        return
      }
      if (this.multipleSelection.length > 10) {
        this.$confirm('批量支付最多选择10条', '', {type: 'warning', showCancelButton: false, showConfirmButton: false}).then(() => {})
        return
      }
      this.currentRow = this.multipleSelection
      this.payDialogVisible = true
    },
    openPayDialog (row) {
      this.currentRow = row
      this.payDialogVisible = true
    },
    handleUploadReceipt (row) {
      // 状态7需要权限校验，其余状态直接跳转上传回执
      if (row.status === 7) {
        this.checkReviewPermission(row)
      } else {
        this.$router.push(`${'/payment-center/upload-receipt/'}${row.id}`)
      }
    },
    checkRejectPermission (row) {
      const params = {
        id: row.id,
        is_test_permission: 1,
      }
      const uri = 'rejectedPayment'
      request.loading(uri, params).then(res => {
        this.$prompt('请填写拒付原因', '提示', {
          inputPattern: /\S+/,
          inputErrorMessage: '请输入拒付原因',
        }).then(({value}) => {
          const confirmParams = {
            id: row.id,
            reject_reason: value,
          }
          this.rejectPayment(uri, confirmParams)
        }).catch(() => {
          this.$message.info('已取消')
        })
      }).catch((_) => {
        this.$alert('当前用户暂无操作权限', '提示', {type: 'warning'}).then(() => {
        })
      })
    },
    // 支付异常处理
    handleProcessPayException (row) {
      const message = `当前付款状态异常，请确认银行是否存在该笔支付并完成异常处理。<br>编号：${row.payment_apply_no}<br>银行指令序列号：${row.bank_f_seq_no}`
      this.$confirm(message, '提示', {
        dangerouslyUseHTMLString: true,
        type: 'warning',
        confirmButtonText: '确认处理',
        cancelButtonText: '取消',
      }).then(async () => {
        try {
          await processPayException(row.id)
          this.$message.success('处理成功')
          this.onRefresh()
        } catch (e) {
          console.log(e)
        }
      }).catch(() => {
      })
    },
    showUploadReceipt (row) {
      if (row.status === 7) return true
      if ([8, 10, 16].includes(row.status)) {
        const files = row.paid_attached_file || []
        return files.length === 0
      }
      return false
    },
    // 手动推送金蝶
    handlePushKingDee (row) {
      this.$confirm('同步数据到金蝶失败，是否重新推送？', '提示', {type: 'warning',
        confirmButtonText: '重新推送',
        cancelButtonText: '取消'
      }).then(() => {
        request.common('pushKingdee', row.id).then(() => {
          this.$message.success('推送成功')
          this.onRefresh()
        }).catch(err => {
          console.log(err)
        })
      })
    },
    // 上传回执
    checkReviewPermission (row) {
      const params = {
        id: row.id,
        is_test_permission: 1
      }
      let uri = ''
      if ([8, 10].includes(row.status)) {
        if (row.write_off_states.includes(6)) {
          uri = 'finAccountantPassPaymentWriteOffData' // 财务会计通过
        } else if (row.write_off_states.includes(7)) {
          uri = 'finManagerPassPaymentWriteOffData' // 财务经理通过
        }
      } else if ([7, 16].includes(row.status)) {
        // 上传回执，和非直连支付: 和之前付款的逻辑是一样，只是 上传回执时，需要回显付款账户
        uri = 'paymentApplication' // 财务付款
      } else if ([6].includes(row.status)) {
        uri = 'managerReviewPaymentApplication' // 财务经理审批
      } if ([5].includes(row.status)) {
        uri = 'accountantReviewPaymentApplication' // 财务会计审批
      }
      request.loading(uri, params).then(res => {
        this.$router.push(`${'/payment-center/upload-receipt/'}${row.id}`)
      }).catch((_) => {
        this.$alert('当前用户暂无操作权限', '提示', {type: 'warning'}).then(() => {
        })
      })
    },
    rejectPayment (uri, params) {
      request.common(uri, params).then((data) => {
        this.$message({
          showClose: true,
          message: '拒付成功',
          type: 'success',
        })
        this.onRefresh()
      })
    },
    onRefund (row) {
      const params = {
        id: row.id,
        is_test_permission: 1
      }
      const uri = 'refundPayment'
      request.loading(uri, params).then(() => {
        this.$router.push(`/payment-center/refund/${row.id}`)
      }).catch(() => {
        this.$alert('当前用户暂无操作权限', '提示', {type: 'warning'}).then(() => {
        })
      })
    },
    getRemovedEmptySearch () {
      return removeEmptyParams(_.cloneDeep(this.search))
    },
    // 按财务格式导出
    exportFinancePaymentList () {
      const searchParams = this.getRemovedEmptySearch()
      this.exportTableData({...searchParams, per_page: 1}).then((res) => {
        if (res.data.total === 0) {
          this.$alert('当前查询条件下没有付款单数据，请调整搜索条件后再导出数据', '提示', {type: 'warning'})
          return
        }
        this.$confirm('确定按搜索条件导出财务格式的付款数据？', '提示', {type: 'warning'}).then(() => {
          request.common('exportFinancePaymentListApi', this.getRemovedEmptySearch()).then((res) => {
            this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: '/batch-jobs/finance-export-jobs'})
            })
          })
        })
      })
    },
    // 导出付款明细
    exportFinancePaymentDetail () {
      const searchParams = this.getRemovedEmptySearch()
      this.exportDetailTableData({...searchParams, per_page: 1}).then((res) => {
        if (res.data.total === 0) {
          this.$alert('当前查询条件下没有付款单数据，请调整搜索条件后再导出数据', '提示', {type: 'warning'})
          return
        }
        this.$confirm('确定按搜索条件导出付款明细数据？', '提示', {type: 'warning'}).then(() => {
          request.common('exportFinancePaymentDetailApi', this.getRemovedEmptySearch()).then((res) => {
            this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: '/batch-jobs/finance-export-jobs'})
            })
          })
        })
      })
    },
    // 导出预付款冲销明细
    exportFinanceWriteOffDetail () {
      const searchParams = this.getRemovedEmptySearch()
      this.exportWriteOffDetailTableData({...searchParams, per_page: 1}).then((res) => {
        if (res.data.total === 0) {
          this.$alert('当前查询条件下没有预付款冲销明细数据，请调整搜索条件后再导出数据', '提示', {type: 'warning'})
          return
        }
        this.$confirm('确定按搜索条件导出预付款冲销明细数据？', '提示', {type: 'warning'}).then(() => {
          request.common('exportFinanceWriteOffDetailApi', this.getRemovedEmptySearch()).then((res) => {
            this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: '/batch-jobs/finance-export-jobs'})
            })
          })
        })
      })
    },
    // 导出预付款冲销状态明细
    exportFinanceWriteOffStatus () {
      const searchParams = this.getRemovedEmptySearch()
      this.exportWriteOffStatusDataRequest({...searchParams, per_page: 1}).then((res) => {
        if (res.data.total === 0) {
          this.$alert('当前查询条件下没有预付款冲销状态明细数据，请调整搜索条件后再导出数据', '提示', {type: 'warning'})
          return
        }
        this.$confirm('确定按搜索条件导出预付款冲销状态明细数据？', '提示', {type: 'warning'}).then(() => {
          request.common('exportFinanceWriteOffStatusApi', this.getRemovedEmptySearch()).then((res) => {
            this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: '/batch-jobs/finance-export-jobs'})
            })
          })
        })
      })
    },
    // 按搜索结果汇总
    showSummaryVisible () {
      const fields = ['pending', '5', '6', '7', 'paid', 'other', 'summary']
      request.page('exportExportSearchAggregateData', removeEmptyParams(this.search)).then(({data}) => {
        data = {
          ...this.defalutValue,
          ...data
        }
        this.paymentSummary = fields.map(field => {
          return data[field]
        })
        this.summaryVisible = true
      })
    },
    // 下载支付结果
    async onDownloadPayRes (row) {
      const id = row && row.id
      if (!id) {
        this.$message.error('缺少记录ID，无法下载')
        return
      }

      if (this.downloadPayResultLoading[id]) return
      this.$set(this.downloadPayResultLoading, id, true)

      try {
        const res = await downloadPayResult(id)
        const url = _.get(res, 'data.detail.download_file_path')
        if (!url) {
          this.$message.error('未获取到下载地址')
          return
        }
        downloadJS(url, false, false, {
          'SJ-Auth-Token': getToken()
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.$set(this.downloadPayResultLoading, id, false)
      }
    },
    // 批量完成
    onFinished () {
      this.onRefresh()
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>





// WEBPACK FOOTER //
// src/views/payment-center/pages/PaymentCenterTable.vue